// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"style_chatContainer__4y0Q8","floatingWrapper":"style_floatingWrapper__19Eev","floatingContainer":"style_floatingContainer__Lbfeq"};